module.exports = __webpack_public_path__ + "img/apps.a896ffea.svg";